<template>
  <div style="text-align: center;">
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>
    
    <div v-if="this.loadingFormSubmit == false">
      <div class="parent">
        <el-dropdown @command="selectRole" trigger="click">
          <el-button type="primary">
          {{selectedRole}}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="role in this.allRoles" :command="role" :key="role.roleid">
                {{role.rolename}}
                <p style="  font-style: italic; font-size: 12px; float: right; margin:0;" v-if="role.customrole == false"> default </p>
              </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-button @click.native="importRolesPermissions()"> Import </el-button>


        <p
        style="margin: 0;
               margin-top: 5px;
               color: red;
               font-size: 13px;"
         v-if="this.roleNotSelected == true"> Please select a role to import </p>

      </div>


      <div style="width: fit-content; margin: auto;">
          <el-input style="    
                           width: 250px;
                           margin: 25px 25px 10px;" 
                    placeholder="Give your role a name"
                    v-model="permissionModelResponse.rolename">
          </el-input>
        
            <p v-if="noName == true" style="font-size: 13px; color: red; text-align: left; margin: 0px 0px 6px 50px;">Name is required </p>
      </div>

      <el-card class="privileges">

          <el-table :data="this.permissions">
 
          <el-table-column prop="privilegename"></el-table-column>

          <el-table-column >
             <template slot-scope="scope">
            <el-switch
              v-model="scope.row.allowed"
              active-color="#13ce66"
              inactive-color="#ff4949">
            ></el-switch>
          </template>
          </el-table-column>

      </el-table>
      </el-card>
      <div  class="buttons-parent">
        <el-button
          style="background-color: #02746E; 
                 color: white;"
          @click.native="submitNewPermission()"
        > Save role</el-button>

        <el-button
        @click.native="closeForm()"
        >Cancel</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
import fab from "vue-fab";

export default {
    data(){
      return{
        permissions: [],
        permissionModelResponse: {},
        roleId: null,
        roleNotSelected: false,
        allRoles: [],
        selectedRole: "Select role",
        noName: false,
        loadingFormSubmit: false
      }
   },
  components:{
    fab
  },
created(){
   EventService.getPermissionsModel().then( response => {
       this.permissionModelResponse = response.data;
       this.permissions = response.data.privilegelist;
   });

   EventService.getAllRoles().then( response => {
    this.allRoles = response.data.roles;
    });
},
methods:{

    submitNewPermission(){
      //a regex to check if user input is empty spaces
        if(this.permissionModelResponse.rolename == null || !this.permissionModelResponse.rolename.replace(/\s/g, ''))
        {
           this.noName = true;
           return
        } 
        else
        {
           this.noName = false;
        }
        
        this.loadingFormSubmit = true;

        EventService.createNewPermission(this.permissionModelResponse).then ( response => {
          
          this.$emit("added-role", response.data)
            this.$store.dispatch("addNotification", {
                type: "success",
                Message: "Role saved"
          });
          
          this.closeForm();
        })
        .catch(error => {
            console.log(error);
            this.closeForm();
        });
    },
    closeForm(){
     this.$emit("close-add-form")
    },
    selectRole(role){
      this.selectedRole = role.rolename;
      this.roleId = role.roleid;
    },
      importRolesPermissions(){ 
        if(this.roleId == null){
          this.roleNotSelected = true;
          return;
        }
        this.roleNotSelected = false;
        EventService.getSingleRoleDetails(this.roleId).then( response => {
         this.permissionModelResponse = response.data;
         this.permissions = response.data.privilegelist;
         this.permissionModelResponse.rolename = "";
   });
      }
},

}
</script>

<style scoped>
.parent{
  margin-top: 100px;
}
.privileges{
   width: 50%;
    margin: auto auto 20px;
    height: calc(100vh - 320px);
    overflow-y: scroll;
}
  .buttons-parent{
  width: 50%;
  margin: auto;
  }
@media (min-width: 250px) and (max-width: 979px) {
.parent{
  margin-top: 60px;
}
.privileges{
   width: 100%;
    height: calc(100vh - 330px);
}
  .buttons-parent{
  width: unset;
  }
}
</style>